import { camelCase } from 'camel-case';

export default camelCase;
